import React from 'react';

import classNames from 'classnames';
import Flags from 'country-flag-icons/react/3x2';

import parseCountryIso2 from './parseCountryIso2';
import styles from './style.less';

export { default as parseCountryIso2 } from './parseCountryIso2';

/**
 * Country flag as an SVG. Emoji is not an option here: Windows renders the
 * regional indicator pair of `PE` as the bare letters instead of a flag.
 *
 * Codes outside ISO 3166-1 alpha-2 (or without artwork) render nothing — never
 * the raw code, which is the platform behaviour we are replacing.
 *
 * Pass `title` when the flag carries the country on its own; without it the
 * flag is decorative and the country name is expected next to it.
 */
const CountryFlag = ({ code, title, className }) => {
  const iso2 = parseCountryIso2(code);
  const Flag = iso2 ? Flags[iso2] : null;
  if (!Flag) return null;

  return (
    <Flag
      className={classNames(styles.flag, className)}
      {...(title
        ? { title, role: 'img', 'aria-label': title }
        : { 'aria-hidden': true, role: 'presentation' })}
    />
  );
};

/**
 * Flag + country label, for table cells, detail rows and selectors.
 * Falls back to the label alone when the code is missing or unknown.
 */
export const CountryWithFlag = ({ code, title, className, children }) => {
  const iso2 = parseCountryIso2(code);
  if (!iso2) return children;

  return (
    <span className={classNames(styles.withFlag, className)} title={title ?? iso2}>
      <CountryFlag code={iso2} />
      <span className={styles.label}>{children}</span>
    </span>
  );
};

export default CountryFlag;
